// extracted by mini-css-extract-plugin
export default {"vertical":"Social_vertical__0JNqa","wrapper":"Social_wrapper__rfncu","item":"Social_item__g48+w","icon":"Social_icon__DL1Xs","horizontal":"Social_horizontal__g5ggK"};